import { getFloatField } from '@lender/utils';

import { TaxFilingType } from 'constants/loanApplication';
import { MIN_NUMBER_VALUE } from 'constants/number';
import {
  titlePer1065TaxReturnOptions,
  titlePer1120sTaxReturnOptions,
  titlePer1120TaxReturnOptions,
} from 'constants/options';

export const EmploymentVerificationTableColumnId = {
  VERIFICATION_TYPE: 'verificationType',
  DATE_COMPLETED: 'dateCompleted',
  VERIFIER_FULL_NAME: 'verifierFullName',
  EMPLOYED_AT_TIME_OF_VERIFICATION: 'employedAtTimeOfVerification',
  ON_TEMPORARY_LEAVE: 'onTemporaryLeave',
  POSITION: 'position',
  HIRE_DATE: 'hireDate',
};

export const defaultEmploymentVerificationSortOrder = {
  direction: 'desc',
  id: EmploymentVerificationTableColumnId.DATE_COMPLETED,
};

export const employmentVerificationFieldsToExcludeOnSave = ['isDeleted', 'isAdded'];

export const EMPLOYMENT_VERIFICATION_NON_PENDING_FIELDS = ['verificationType'];

export const titlePerTaxReturnOptions = {
  [TaxFilingType.FORM_1040_SCHEDULE_C]: [],
  [TaxFilingType.FORM_1065]: titlePer1065TaxReturnOptions,
  [TaxFilingType.FORM_1120]: titlePer1120TaxReturnOptions,
  [TaxFilingType.FORM_1120S]: titlePer1120sTaxReturnOptions,
};

export const SCROLL_DELAY_MS = 200;

export const PREVIOUS_EMPLOYMENT_AMOUNT_INPUT_PROPS = {
  required: false,
  allowNegative: true,
  minValue: MIN_NUMBER_VALUE,
  customSchema: getFloatField,
};
